import types from './settingTypes'

const setSettingOperators = (items: []) => ({ type: types.SETTING_SET_OPERATORS, items })
const setSettingLevelUmkd = (items: []) => ({ type: types.SETTING_SET_LEVEL_UMKD, items })
const setSettingDictDirectionTraining = (items: []) => ({ type: types.SETTING_SET_DICT_DIRECTION_TRAINING, items })
const setSettingDictEducationalProgram = (items: []) => ({ type: types.SETTING_SET_DICT_EDUCATIONAL_PROGRAM, items })
const setSettingGroups = (assignedGroupsList: [], unassignedGroupsList: []) => ({ type: types.SETTING_SET_GROUPS, assignedGroupsList, unassignedGroupsList })

const settingActions = {
    setSettingOperators,
    setSettingLevelUmkd,

    setSettingDictDirectionTraining,
    setSettingDictEducationalProgram,

    setSettingGroups,
}

export default settingActions